import type { IAuthor, ICasino, INavItem, ISiteNavigation } from '@anywayseo/tools';
import { StaticImage } from 'gatsby-plugin-image';
import { ReactElement } from 'react';

export const author: IAuthor = {
  name: 'Ivonete Junqueirac',
  role: 'especialista em jogos online',
  bio: 'Olá! Chamo-me Ivonete Junqueira e sou a editora-chefe do portal JogosBingoOnline.com. No meu trabalho, analiso cassinos online, teste as plataformas de apostas e avalie as aplicações de cassino. Com muitos anos de experiência no setor de jogos online, o meu objetivo é fornecer informações confiáveis e ajudar os jogadores brasileiros a encontrar as melhores opções de entretenimento.',
  avatar: (
    <StaticImage
      src={'./assets/authors/ivonete-junqueirac.jpg'}
      alt='Ivonete Junqueirac'
      style={{ borderRadius: '50%' }}
    />
  ),
  socialNetworks: [
    {
      kind: 'linkedin',
      url: 'https://www.linkedin.com/in/ivonete-junqueirac-3a594a30a/',
    },
    {
      kind: 'instagram',
      url: 'https://www.instagram.com/ivonetejunqueira?igsh=MXJqb3pkeWg3NGhqYQ==',
    },
  ],
};

const gameRoutes: INavItem[] = [
  { slug: '', label: 'Jogos de bingo grátis' },
  { slug: 'show-ball-3', label: 'Show Ball 3' },
  { slug: 'silverball', label: 'Silverball' },
  { slug: 'nine-balls', label: 'Nine Balls' },
  { slug: 'banana-bingo', label: 'Banana Bingo' },
];

const blogRoutes: INavItem[] = [
  { slug: '', label: 'Todos os artigos' },
  { slug: 'bingo-e-legalizado-no-brasil', label: 'O bingo é permitido no Brasil?' },
  { slug: 'como-ganhar-no-bingo', label: 'Como Ganhar no Bingo Online: Dicas e Estratégias Infalíveis' },
];

export const localNavigation: ISiteNavigation = {
  header: {
    'pt-BR': [
      { slug: 'bingo-gratis', label: 'Bingo Grátis', children: gameRoutes },
      { slug: 'bingo-bonus', label: 'Bingo Bonus' },
      { slug: 'bingo-blog', label: 'Bingo Blog', children: blogRoutes },
    ],
  },
  footer: {
    'pt-BR': [
      { slug: 'privacy-policy', label: 'Política de privacidade' },
      { slug: 'cookie-policy', label: 'Política de Cookies' },
      { slug: 'copyright-notice', label: 'Aviso de direitos autorais' },
      { slug: 'contatos', label: 'Contatos' },
      { slug: 'age-restrictions', label: '18+' },
    ],
  },
};

const DEFAULT_PAYOUT = '0-24 horas';

export const casinos: ICasino[] = [
  {
    id: '1',
    name: 'LeoVegas Casino',
    rating: 9.1,
    bonus: 'R$5.000 em dinheiro + 50 Giros Grátis!',
    info: {
      PAYOUT_SPEED: DEFAULT_PAYOUT,
    },
    image: (
      <StaticImage
        src='./assets/casinos/leovegas_500x250.png'
        alt='LeoVegas'
        width={500}
        placeholder='blurred'
        backgroundColor='#ff6600'
      />
    ),
  },
  {
    id: '2',
    name: 'Lvbet Casino',
    rating: 9.1,
    bonus: '100% até 2000 reais',
    info: {
      PAYOUT_SPEED: DEFAULT_PAYOUT,
    },
    image: (
      <StaticImage
        src='./assets/casinos/lvbet_500x250.png'
        alt='LVBet'
        width={500}
        placeholder='blurred'
        backgroundColor='#04020d'
      />
    ),
  },
  {
    id: '3',
    name: 'Betsson Casino',
    rating: 8.9,
    bonus: '100 % até 600 R$',
    info: {
      PAYOUT_SPEED: DEFAULT_PAYOUT,
    },
    image: (
      <StaticImage
        src='./assets/casinos/betsson_500x250.svg'
        alt='Betsson'
        width={500}
        placeholder='blurred'
        backgroundColor='#ff6600'
      />
    ),
  },
  {
    id: '4',
    name: 'Mostbet Casino',
    rating: 8.8,
    bonus: '100 % até 1.700 R$ e 250 rondas extra (0,6 R$/ronda)',
    info: {
      PAYOUT_SPEED: DEFAULT_PAYOUT,
    },
    image: (
      <StaticImage
        src='./assets/casinos/mostbet_500x250.svg'
        alt='Mostbet'
        width={500}
        placeholder='blurred'
        backgroundColor='#003a77'
      />
    ),
  },
  {
    id: '5',
    name: '188BET Casino',
    rating: 8.7,
    bonus: 'O Bônus de Primeiro Depósito de 100% até BRL200!',
    info: {
      PAYOUT_SPEED: DEFAULT_PAYOUT,
    },
    image: (
      <StaticImage
        src='./assets/casinos/188bet_500x250.png'
        alt='188BET'
        width={500}
        placeholder='blurred'
        backgroundColor='#111111'
      />
    ),
  },
  {
    id: '6',
    name: 'Betfair Casino',
    rating: 8.6,
    bonus: 'Bônus de 300% até R$12000 além de 20 giros grátis',
    info: {
      PAYOUT_SPEED: DEFAULT_PAYOUT,
    },
    image: (
      <StaticImage
        src='./assets/casinos/betfair_500x250.png'
        alt='Betfair'
        width={500}
        placeholder='blurred'
        backgroundColor='#ffb80c'
      />
    ),
  },
  {
    id: '7',
    name: 'BetBoom Casino',
    rating: 8.5,
    bonus: 'Bônus de boas-vindas para os primeiros 3 depósitos Até 100FS e 1 000 EUR',
    info: {
      PAYOUT_SPEED: DEFAULT_PAYOUT,
    },
    image: (
      <StaticImage
        src='./assets/casinos/betboom_500x250.png'
        alt='BetBoom'
        width={500}
        placeholder='blurred'
        backgroundColor='#1f1f1f'
      />
    ),
  },
  {
    id: '8',
    name: 'Dafabet Casino',
    rating: 8.3,
    bonus: 'Bônus de 100% em seu primeiro depósito até R$500',
    info: {
      PAYOUT_SPEED: DEFAULT_PAYOUT,
    },
    image: (
      <StaticImage
        src='./assets/casinos/dafabet_500x250.png'
        alt='Dafabet'
        width={500}
        placeholder='blurred'
        backgroundColor='#ae0001'
      />
    ),
  },
  {
    id: '9',
    name: 'Stake Casino',
    rating: 8.1,
    bonus: 'Bônus de 40x em até R$1000',
    info: {
      PAYOUT_SPEED: DEFAULT_PAYOUT,
    },
    image: (
      <StaticImage
        src='./assets/casinos/stake_500x250.png'
        alt='Stake'
        width={500}
        placeholder='blurred'
        backgroundColor='#172135'
      />
    ),
  },
  {
    id: '10',
    name: 'BetAndreas Casino',
    rating: 7.7,
    bonus: 'BÔNUS 250 FS +1 700BRLBÔNUS 250 FS +1 700BRL NO PRIMEIRO DEPÓSITO',
    info: {
      PAYOUT_SPEED: DEFAULT_PAYOUT,
    },
    image: (
      <StaticImage
        src='./assets/casinos/betandreas_500x250.png'
        alt='BetAndreas'
        width={500}
        placeholder='blurred'
        backgroundColor='#1f1f1f'
      />
    ),
  },
  {
    id: '11',
    name: 'Blaze Casino',
    rating: 7.5,
    bonus: 'Blaze 100% bônus de depósito + 40 rodadas grátis',
    info: {
      PAYOUT_SPEED: DEFAULT_PAYOUT,
    },
    image: (
      <StaticImage
        src='./assets/casinos/blaze_500x250.png'
        alt='Blaze'
        width={500}
        placeholder='blurred'
        backgroundColor='#1f1f1f'
      />
    ),
  },
  {
    id: '12',
    name: 'PIN UP Casino',
    rating: 7.3,
    bonus: '250 FS 100% no primeiro depósito',
    info: {
      PAYOUT_SPEED: DEFAULT_PAYOUT,
    },
    image: (
      <StaticImage
        src='./assets/casinos/pinup_500x250.svg'
        alt='PIN UP'
        width={500}
        placeholder='blurred'
        backgroundColor='#1f1f1f'
      />
    ),
  },
  {
    id: '13',
    name: 'NetBet Casino',
    rating: 6.9,
    bonus: 'Jogue video bingo com um bônus de boas-vindas até R$800 + 10 rodadas grátis',
    info: {
      PAYOUT_SPEED: DEFAULT_PAYOUT,
    },
    image: (
      <StaticImage
        src='./assets/casinos/netbet_500x250.png'
        alt='NetBet'
        width={500}
        placeholder='blurred'
        backgroundColor='#262932'
      />
    ),
  },
  {
    id: '14',
    name: '1XBET Casino',
    rating: 6.7,
    bonus: 'Bônus de 100% em até R$1500',
    info: {
      PAYOUT_SPEED: DEFAULT_PAYOUT,
    },
    image: (
      <StaticImage
        src='./assets/casinos/1xbet_500x250.svg'
        alt='1XBET'
        width={500}
        placeholder='blurred'
        backgroundColor='#165588'
      />
    ),
  },
  {
    id: '15',
    name: 'Bodog Casino',
    rating: 6.5,
    bonus: 'Bônus de 100% em até R$5000',
    info: {
      PAYOUT_SPEED: DEFAULT_PAYOUT,
    },
    image: (
      <StaticImage
        src='./assets/casinos/bodog_500x250.svg'
        alt='Bodog'
        width={500}
        placeholder='blurred'
        backgroundColor='#1f1f1f'
      />
    ),
  },
  {
    id: '16',
    name: 'CyberBet Casino',
    rating: 2.8,
    bonus: 'Não oferece bônus',
    info: {
      PAYOUT_SPEED: DEFAULT_PAYOUT,
    },
    image: (
      <StaticImage
        src='./assets/casinos/cyberbet_500x250.png'
        alt='CyberBet'
        width={500}
        placeholder='blurred'
        backgroundColor='#0039e0'
      />
    ),
  },
];

export const GamePreviewImageMap: Record<string, ReactElement> = {
  ['show-ball-3']: (
    <StaticImage
      alt='ShowBall 3 Preview'
      src='./assets/games/show-ball-3-preview.jpg'
      objectFit='cover'
      style={{ width: '100%', height: '100%' }}
    />
  ),
  ['silverball']: (
    <StaticImage
      alt='Silverball Preview'
      src='./assets/games/silverball-preview.png'
      objectFit='cover'
      style={{ width: '100%', height: '100%' }}
    />
  ),
  ['nine-balls']: (
    <StaticImage
      alt='Nine Balls Preview'
      src='./assets/games/nine-balls-preview.png'
      objectFit='cover'
      style={{ width: '100%', height: '100%' }}
    />
  ),
  ['banana-bingo']: (
    <StaticImage
      alt='Banana Bingo Preview'
      src='./assets/games/banana-bingo-preview.png'
      objectFit='cover'
      style={{ width: '100%', height: '100%' }}
    />
  ),
};

export const ArticlePreviewImageMap: Record<string, ReactElement> = {
  ['bingo-e-legalizado-no-brasil']: (
    <StaticImage
      alt='Como fazer um bingo permitido'
      src='./assets/articles/bingo-é-permitido.webp'
      objectFit='cover'
      style={{ height: '100%', maxWidth: 800 }}
    />
  ),
  ['como-ganhar-no-bingo']: (
    <StaticImage
      alt='Como ganhar no bingo'
      src='./assets/articles/trofeu-segurado-na-mao-com-fichas-de-jogo-e-numero-27-estilo-cartoon-colorido.jpg'
      objectFit='cover'
      style={{ height: '100%', maxWidth: 800 }}
    />
  ),
};
